import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "footPage XhorizontalCenter" }
const _hoisted_2 = { class: "foot pageWidth" }
const _hoisted_3 = { class: "foot_content" }
const _hoisted_4 = { class: "foot_left" }
const _hoisted_5 = { class: "foot_images_container" }
const _hoisted_6 = { class: "foot_logo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "foot_qrCodeContainer" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "foot_right" }
const _hoisted_11 = { class: "foot_menuBar" }
const _hoisted_12 = { class: "foot_menuBar_link" }
const _hoisted_13 = { class: "bar" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "foot_menuBar_aboutUs" }
const _hoisted_16 = { class: "bar" }
const _hoisted_17 = { class: "foot_copyright" }
const _hoisted_18 = ["href"]

import { onMounted, reactive } from "vue";
import * as api from "@/api";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'foot',
  props: {
  logo: [],
},
  emits: ["toTop"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const props = __props;
const emits = __emit;
const pageSrc = reactive({
  log: "页面创建了",
  fastLink: [] as any,
  connect: [] as any,
  filing: [] as any,
  qrCode: [] as any,
});
onMounted(async () => {
  fastLink();
  connect();
  filing();
  getQrCode();
});
const setTitle = (item: any) => {
  document.title = item + "标题";
};
/**
 * 获取快速链接
 */
const fastLink = async () => {
  try {
    const res = await api.getPageMessage(143);
    pageSrc.fastLink = res?.data.content_list;
  } catch (e) {
    console.error(e);
  }
};
/**
 * 获取公司二维码
 */
const getQrCode = async () => {
  try {
    const res = await api.getAdImgAndVideo(50);
    pageSrc.qrCode = res?.data.ad_list[0].pic;
  } catch (e) {
    console.error(e);
  }
};
/**
 * 获取备案号
 */
const filing = async () => {
  try {
    const res = await api.getPageMessage(145);
    pageSrc.filing = res?.data.content_list;
  } catch (e) {
    console.error(e);
  }
};
/**
 * 获取联系方式
 */
const connect = async () => {
  try {
    const res = await api.getPageMessage(263);
    pageSrc.connect = res?.data.content_list;
  } catch (e) {
    console.error(e);
  }
};
const toTemplate = (item: any, index: number) => {
  if (item.jump_link == "/") return;
  const items = item.jump_link.split("_");
  items[0] = items[0].split("/")[1];
  router.push({
    name: items[0],
    query: {
      componentId: items[2],
      name: item.title,
      waitsources: items[1],
      adId: items[3],
    },
  });
  toTop();
};
const toTop = () => {
  emits("toTop", "");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: props.logo,
                alt: "公司logo"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                class: "foot_qrCode",
                src: pageSrc.qrCode,
                alt: "公司二维码"
              }, null, 8, _hoisted_9),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "qrCode_tooltip" }, "扫码关注我们", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "快速链接", -1)),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSrc.fastLink, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: ($event: any) => (toTemplate(item, index)),
                    key: index,
                    class: "menu_item"
                  }, _toDisplayString(item.title), 9, _hoisted_14))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, "联系我们", -1)),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSrc.connect, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "menu_item"
                  }, _toDisplayString(item.title), 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSrc.filing, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("a", {
                  href: item.jump_link,
                  target: "_blank"
                }, _toDisplayString(item.title), 9, _hoisted_18)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})